module.exports = __webpack_public_path__ + "img/outline-add_circle_outline-24px.e4f6f279.svg";